import React, { useContext, useEffect, useState } from "react";
import AllCategory1 from '../Assets/ResidentialProperties1.png'
import { Get_Api } from "../ApiUrls";
import { useNavigate } from "react-router-dom";
import { CategoryContext } from "./CategoryProvider";
import EnquiryModel from "./EnquiryModel";


const AllProperties = () => {
    const navigate = useNavigate()
    const [IsUploading, setIsUploading] = useState(false);
    const { setSelectedCategory, selectedCategory, allCategories } = useContext(CategoryContext);


    const [All_Locations, setAll_Locations] = useState([]);
    const Get_All_Locations = async () => {
        try {
            setIsUploading(true);
            const response = await Get_Api('api/admin/GetAllNewLocation');
            setAll_Locations(response.data);
            setIsUploading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        Get_All_Locations();
    }, []);



    const [Properties, setProperties] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [Location, setLocation] = useState('');

    const GetAllProperties = async () => {
        try {
            setIsUploading(true);
            const queryParams = new URLSearchParams();

            if (selectedCategory) {
                queryParams.append("Category", selectedCategory);
            }
            if (Location) {
                queryParams.append("Location", Location);
            }
            if (searchKeyword) {
                queryParams.append("Name", searchKeyword);
            }

            const response = await Get_Api(`api/admin/GetProperties?${queryParams.toString()}`);
            setProperties(response?.data);
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            console.log(error);
        }
    };

    useEffect(() => {
        GetAllProperties();
    }, []);


    const Propertydetails = (id) => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        navigate(`/PropertyDetails/${id}`)
    }

    const Search = () => {
        GetAllProperties();
    }

    const [selectedProperty, setselectedProperty] = useState(null);

    const [isOpenEnquiryModel, setisOpenEnquiryModel] = useState(false);

    const OpenEnquiryModel = (id) => {
        setselectedProperty(id)
        setisOpenEnquiryModel(true)
    }
    const CloseEnquiryModel = () => {
        setselectedProperty(null)
        setisOpenEnquiryModel(false)
    }


    return (
        <div className="container">
            <h2 className="heading">Advanced Search</h2>
            <div className="search-bar">
                <select
                    className="search-select"
                    value={Location}
                    onChange={(e) => { setLocation(e.target.value) }}
                >
                    <option value='' disabled hidden>Select Location*</option>
                    {All_Locations?.map((location, index) => (
                        <option key={index} value={location?._id}>
                            {location?.Location}
                        </option>
                    ))}
                </select>
                <select>
                    <option
                        className="search-select"
                        value={selectedCategory}
                        onChange={(e) => setSelectedCategory(e.target.value)}
                        disabled hidden>Select Property Type*</option>
                    {allCategories?.map((category, index) => (
                        <option key={index} value={category?._id}>
                            {category?.Name}
                        </option>
                    ))}
                </select>
                <input type="text" placeholder="Sq ft" className="search-input" />
                <select>
                    <option value='' >Min Budget *</option>
                    <option>5 lac</option>
                    <option>10 lac</option>
                    <option>20 lac</option>
                    <option>30 lac</option>
                    <option>40 lac</option>
                    <option>50 lac</option>
                    <option>60 lac</option>
                    <option>70 lac</option>
                    <option>80 lac</option>
                    <option>90 lac</option>
                    <option>1 cr</option>
                    <option>1.2 cr</option>
                    <option>1.4 cr</option>
                    <option>1.6 cr</option>
                    <option>1.8 cr</option>
                    <option>2 cr</option>
                    <option>3 cr</option>
                    <option>4 cr</option>
                    <option>5 cr</option>
                    <option>6 cr</option>
                    <option>7 cr</option>
                    <option>8 cr</option>
                    <option>9 cr</option>
                    <option>10 cr</option>
                    <option>20 cr</option>
                    <option>30 cr</option>
                    <option>40 cr</option>
                    <option>50 cr</option>
                    <option>100 cr</option>
                </select>
                <select>
                    <option value='' >Max Budget *</option>
                    <option>5 lac</option>
                    <option>10 lac</option>
                    <option>20 lac</option>
                    <option>30 lac</option>
                    <option>40 lac</option>
                    <option>50 lac</option>
                    <option>60 lac</option>
                    <option>70 lac</option>
                    <option>80 lac</option>
                    <option>90 lac</option>
                    <option>1 cr</option>
                    <option>1.2 cr</option>
                    <option>1.4 cr</option>
                    <option>1.6 cr</option>
                    <option>1.8 cr</option>
                    <option>2 cr</option>
                    <option>3 cr</option>
                    <option>4 cr</option>
                    <option>5 cr</option>
                    <option>6 cr</option>
                    <option>7 cr</option>
                    <option>8 cr</option>
                    <option>9 cr</option>
                    <option>10 cr</option>
                    <option>20 cr</option>
                    <option>30 cr</option>
                    <option>40 cr</option>
                    <option>50 cr</option>
                    <option>100 cr</option>
                </select>
                <button
                    className="search-button"
                    onClick={() => { Search() }}
                >Search</button>
            </div>

            <h3 className="sub-heading">Popular Category</h3>
            <br />
            <div className="category-buttons">
                {allCategories?.map((category) => (
                    <button
                        key={category?._id}
                        className={`category-button ${selectedCategory === category?._id ? "active" : ""
                            }`}
                        onClick={() => {
                            setSelectedCategory(category?._id)
                        }
                        }
                    >
                        {category?.Name}
                    </button>
                ))}
            </div>
            <br />
            <br />
            <div className="property-grid">
                {Properties?.length > 0 ? (
                    Properties.map((property, index) => (
                        <div className="property-card" key={index}>
                            <div className="image-wrapper">
                                <img
                                    src={property?.MainImage || AllCategory1}
                                    alt={property?.Name}
                                    className="property-image"
                                />
                                {!property?.featured && <span className="featured-badge">Featured</span>}
                                <span onClick={() => { OpenEnquiryModel(property?._id) }} style={{ cursor: 'pointer' }} className="featured-badge2">Price On Request</span>
                                {/* <div onClick={() => { Propertydetails(property?._id) }} className="overlay">View Details ↗</div> */}
                            </div>
                            <h2 className="property-title">{property?.Name}</h2>
                            {/* <p className="property-price">INR.  {property?.Price}</p> */}
                            <div className="property-info">
                                <span className="location">📍 {property?.Address}</span>
                                {/* <span className="size">📏 {property?.PerSquarePrice}</span> */}
                            </div>
                            <button className="seeprop" onClick={() => { Propertydetails(property?._id) }}>See Details</button>
                        </div>
                    ))
                ) : (
                    <p className="no-properties-message">No properties found in this category.</p>
                )}
            </div>
            <EnquiryModel
                isOpen={isOpenEnquiryModel}
                onClose={CloseEnquiryModel}
                selectedProperty={selectedProperty}
            />
        </div>
    );
};

export default AllProperties;
